<div class="loader" *ngIf="userDetailsLoading">
</div>

<div class="tv-card custom-margin" *ngIf="!userDetailsLoading">
    <app-profile [editProfileFlow]="true" [userDetails]="userObj"></app-profile>
</div>